import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';

/**
 * `<clam-spinner>` — spinner circular reutilizable (consolida el `.spinner`+`@keyframes spin`
 * que estaba duplicado en confirmar / registration-form / admin). Usa tokens `--clam-*`.
 *
 * Uso: `<clam-spinner size="md"></clam-spinner>` · `<clam-spinner size="lg" color="#1a3a5c">`.
 */
@customElement('clam-spinner')
export class ClamSpinner extends LitElement {
	static styles = css`
		:host {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			vertical-align: middle;
		}
		.spinner {
			display: inline-block;
			box-sizing: border-box;
			vertical-align: middle;
			width: var(--cs-size, 24px);
			height: var(--cs-size, 24px);
			border: var(--cs-thickness, 3px) solid var(--cs-track, var(--clam-border, #e2e8f0));
			border-top-color: var(--cs-color, var(--clam-primary, #5a9d1e));
			border-radius: 50%;
			animation: clam-spin 0.8s linear infinite;
		}
		@keyframes clam-spin {
			to {
				transform: rotate(360deg);
			}
		}
	`;

	@property() size: 'sm' | 'md' | 'lg' = 'md';
	@property() color?: string;
	@property() track?: string;

	render() {
		const px = this.size === 'sm' ? 16 : this.size === 'lg' ? 40 : 24;
		const thick = this.size === 'sm' ? 2 : this.size === 'lg' ? 4 : 3;
		const style = `--cs-size:${px}px;--cs-thickness:${thick}px;${this.color ? `--cs-color:${this.color};` : ''}${this.track ? `--cs-track:${this.track};` : ''}`;
		return html`<span class="spinner" style=${style}></span>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'clam-spinner': ClamSpinner;
	}
}
